import React from "react";
import "../styles/components/SearchSuggestion.scss";
import Utility from "../utility/Utility";
import { Trans } from "react-i18next";

const SearchSuggtion = (props: any) => {
  return (
    <div
      className="suggestionCard text-capitalize"
      onClick={props.onSuggestion}
    >
      <div className="left">
        <div className="text-center left-inner bg-light-gray">
          <img src={`/icons/${props.data?.gender || "male"}.svg`} alt="" />
          <span className={props?.data?.gender || "male"}>
            {props?.data?.gender ? (
              <Trans i18nKey={props?.data?.gender}></Trans>
            ) : (
              <Trans i18nKey={"unavailable"} />
            )}
          </span>
        </div>
      </div>
      <div className="right">
        <div className="row">
          <div className="col-sm">
            <label className="label-1">
              {Utility.patientName(props.data?.name)}
            </label>
          </div>
          <div className="col-sm text-sm-start text-start text-sm-end text-md-end">
            <label className="label-1">
              {<Trans i18nKey={Utility.getIDString(props.data)}></Trans>} -{" "}
              {Utility.getIDNumber(props.data) === "unavailable" ? (
                <Trans i18nKey="unavailable"></Trans>
              ) : (
                Utility.getIDNumber(props.data)
              )}
            </label>
          </div>
        </div>
        <span>
          {Utility.getAge(props.data?.birthDate)} |{" "}
          <Trans i18nKey={"dob"}></Trans> :{" "}
          {Utility.formatDate(props.data?.birthDate) || (
            <Trans i18nKey={"unavailable"} />
          )}
        </span>
        <div className="contact">
          <img src="/icons/contact.svg" alt="" />
          <span>
            {" "}
            {Utility.patientMobileNumber(props.data?.telecom) || (
              <Trans i18nKey={"unavailable"} />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SearchSuggtion;
